import {
  Button,
  formatCurrency,
  getFormattedPrice,
  Icon,
  Typography
} from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ShoppingCart } from '@hero/components/organisms';
import { useShoppingCart } from '@hero/store/hooks';

export default function WidgetFooter(props) {
  const { t } = useTranslation();
  const { setOpened } = useShoppingCart();

  function handleConfirm() {
    setOpened(false);
    props.onConfirmCart?.();
  }

  return (
    <>
      <ShoppingCart.S.WidgetFooterSubtotal>
        <Typography variant="body2">
          {t('priceRange')}:
          <Typography variant="body1Bold" as="span">
            {props.products?.length > 0
              ? getFormattedPrice({ min: props?.minPrice, max: props?.maxPrice })
              : formatCurrency(0)}
          </Typography>
        </Typography>
      </ShoppingCart.S.WidgetFooterSubtotal>
      <ShoppingCart.S.FooterActionButtons>
        <Button endIcon={<Icon name="next" />} onClick={handleConfirm} block>
          {t('continue')}
        </Button>
      </ShoppingCart.S.FooterActionButtons>
    </>
  );
}
